<template>
  <div class="input-group">
    <slot></slot>
    <div class="input-group-btn">
      <button type="button" class="btn btn-default qty-dec-btn"
              :disabled="disabled"
              title="Decrement"
              aria-label="Decrement quantity"
              @click="decrementValue">-
      </button>
    </div>
    <input type="text" class="qty-input"
           :disabled="disabled"
           :value="value"
           title="Quantity"
           aria-label="Quantity to add to cart"
           @keyup.up="incrementValue"
           @keyup.down="decrementValue"
           @input="updateValue">
    <div class="input-group-btn">
      <button type="button" class="btn btn-default qty-inc-btn"
              :disabled="disabled"
              title="Increment"
              aria-label="Increment quantity"
              @click="incrementValue">+
      </button>
    </div>
  </div>
</template>

<script>
  export default {
    name: "base-number-input",
    props: {
      value: {
        required: true,
        type: Number,
      },
      min: {
        type: Number,
        default: 1,
      },
      max: {
        type: Number,
        default: undefined,
      },
      disabled:{
        type: Boolean,
        default: false,
      }
    },
    methods: {
      incrementValue(e) {
        if (typeof this.max === 'undefined') {
          this.$emit('input', this.value + 1)
          return
        }
        if (this.value + 1 <= this.max) {
          this.$emit('input', this.value + 1)
        }
      },
      decrementValue(e) {
        if (this.value - 1 >= this.min) {
          this.$emit('input', this.value - 1)
        }
      },
      updateValue(e) {
        try {
          let val = parseInt(e.target.value)
          if (val < this.min) {
            this.$emit('input', this.min)
            return
          }
          if (typeof this.max !== 'undefined' && val > this.max) {
            this.$emit('input', this.max)
            return
          }
          if(val+'' !== 'NaN'){
            this.$emit('input', val)
            return
          }
          throw val
        } catch (ex) {
          this.$forceUpdate()
        }
      },
    },
  }
</script>

<style scoped>
  .qty-dec-btn, .qty-inc-btn {
    display: inline-flex;
    line-height: 14px;
    align-items: center;
    justify-content: center;
  }

  .input-group {
    max-width: 85px;
    display: inline-table;
  }
</style>



// WEBPACK FOOTER //
// ixcms/themes/src/vue-src/base/_base-number-input.vue